module.exports = __webpack_public_path__ + "img/t5-3.8213165d.svg";